import { Localized } from "@fluent/react"
import { Alert, Checkbox, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Stack } from "@mui/material"
import { regenerateCompanySettings } from "./defaultCompanySettingsApi";
import { useEffect, useState } from "react";
import { SaveButton } from "../../../app/components/SaveButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { loadCompanies, selectAllCompanies, selectCompanies } from "../companiesSlice";

interface RegenerateCompanySettingsDialogProps {
    onCancel: () => void;
}

export const RegenerateCompanySettingsDialog: React.FC<RegenerateCompanySettingsDialogProps> = ({ onCancel }) => {
    const dispatch = useAppDispatch();
    const { loaded } = useAppSelector(selectCompanies);
    const companies = useAppSelector(selectAllCompanies);

    const [company, setCompany] = useState('all');
    const [overwrite, setOVerwrite] = useState<boolean>(false);

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleCompanyChange = (event) => setCompany(event.target.value);
    const handleOverwriteChange = (event) => setOVerwrite(event.target.checked);

    useEffect(() => {
        if (!loaded) {
            dispatch(loadCompanies())
        }
    }, [dispatch, loaded]);

    const handleConfirm = async () => {
        try {
            const result = await dispatch(regenerateCompanySettings({ overwrite, companyId: company !== "all" ? Number(company) : undefined }))
            if (regenerateCompanySettings.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onCancel();
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="default-company-settings-regenerate-settings">
                    <span>_Przegeneruj ustawienia dla firm</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2} padding={2}>
                    <FormControl>
                        <InputLabel id="select-company-label"><Localized id="company">Firma</Localized></InputLabel>
                        <Select
                            labelId="select-company-label"
                            value={company}
                            onChange={handleCompanyChange}
                            label={<Localized id="company">Firma</Localized>}
                        >
                            <MenuItem value={'all'}>
                                <Localized id="all">All</Localized>
                            </MenuItem>
                            {companies.map((option) =>
                                <MenuItem value={option.id}>{option.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={overwrite}
                                onChange={handleOverwriteChange} />}
                        label={<Localized id="default-company-settings-overwrite"><span>_Nadpisz istniejące</span></Localized>}
                    />
                </Stack>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <SaveButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}